import React from "react";
import { Button, Popconfirm, Typography } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import Can from "../components/Can";
import { PERMISSIONS } from "./permissions";

const { Text } = Typography;

/**
 * Fields stored inside `pricing_data`. The form and the table read the same
 * list so both stay in sync when a charge is added or renamed.
 */
export const PRICING_FIELDS = [
  {
    key: "ALLOWED_RENTAL_DAYS",
    label: "Allowed Rental Days",
    shortLabel: "Allowed Rental Days",
    min: 1,
  },
  {
    key: "BATTERY_PER_HOUR_CHARGE",
    label: "Battery Per Hour Charge",
    shortLabel: "Per Hour Charge",
    min: 0,
  },
  {
    key: "BATTERY_PER_DAY_CHARGE",
    label: "Battery Per Day Charge",
    shortLabel: "Per Day Charge",
    min: 0,
  },
  {
    key: "BATTERY_KEEP_CHARGE",
    label: "Battery Keep Charge",
    shortLabel: "Keep Charge",
    min: 0,
  },
  {
    key: "BATTERY_MAX_CHARGES_WITH_TAXES",
    label: "Battery Max Charges With Taxes",
    shortLabel: "Max Charge (With Taxes)",
    min: 0,
  },
];

/**
 * PRICING TABLE
 */
export const pricingTable = (onEdit, onDelete) => [
  {
    title: "Sr. No",
    key: "index",
    width: 80,
    render: (_, __, index) => index + 1,
  },
  {
    title: "Name",
    key: "pricing_name",
    dataIndex: "pricing_name",
    render: (item) => <Text strong>{item || "--"}</Text>,
  },
  ...PRICING_FIELDS.map(({ key, shortLabel }) => ({
    title: shortLabel,
    key,
    dataIndex: ["pricing_data", key],
    className: "col-mono",
    render: (item) =>
      item === null || item === undefined || item === "" ? "--" : item,
  })),
  {
    title: "Action",
    key: "action",
    align: "right",
    className: "col-actions",
    fixed: "right",
    render: (_, record) => (
      <div className="d-flex" style={{ gap: 8, justifyContent: "flex-end" }}>
        <Can permissions={[PERMISSIONS.UPDATE_PRICINGS]}>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => onEdit(record)}
          >
            Update
          </Button>
        </Can>

        <Can permissions={[PERMISSIONS.DELETE_PRICINGS]}>
          <Popconfirm
            title="Are you sure you want to delete this pricing?"
            onConfirm={() => onDelete(record)}
            okText="Yes"
            cancelText="No"
          >
            <Button danger type="primary" icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm>
        </Can>
      </div>
    ),
  },
];
